import { useTranslation } from 'react-i18next';
import styles from './DocumentViewer.module.css';

interface DocumentViewerProps {
	type: 'front' | 'back';
	data: string;
	contentType: string;
}

const DocumentViewer = (props: DocumentViewerProps) => {
	const { t } = useTranslation();

	const isBase64 = !props.data.startsWith('blob:');
	const src = isBase64 ? `data:${props.contentType};base64,${props.data}` : props.data;

	if (props.contentType === 'application/pdf') {
		return (
			<div className={styles.fileContainer}>
				<iframe src={src} title={`PDF ${props.type}`} width="100%" height="100%" className={styles.fileContent} />
				{/* Fallback per mobile */}
				<div className={styles.mobileDownload}>
					<p>{t('adminPage.signaller.downloadDoc')}:</p>
					<a href={src} download={`documento-${props.type}.pdf`} className={styles.downloadLink}>
						📄 {t('adminPage.signaller.downloadDocBtn')}
					</a>
				</div>
			</div>
		);
	} else if (props.contentType.startsWith('image/')) {
		return (
			<div className={styles.imgContainer}>
				<img src={src} alt={`Documento ${props.type}`} className={styles.imgContent} />
			</div>
		);
	} else {
		return <p>{t('adminPage.signaller.formatError')}</p>;
	}
};

export default DocumentViewer;
